// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"_d852603","raceCount":"_15af43c","icon":"_bc50e5b","iconOpen":"_f8e9b09","raceCountdown":"_60b31dd"};